import React, {FC} from 'react';
import {ThemeProvider} from 'styled-components';

import {expandedDarkTheme} from '../../../../libs/shared/ui/src/theme/dark/darkTheme';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {UserThemesEnum} from '../../../../libs/shared/ui/src/theme/userThemesEnum';
import {useAppSelector} from '../../../helpers/reduxHelpers';
import {getTheme} from '../../../store/data/preferences/preferencesSelectors';
import {getHasP2P3DarkMode} from '../../../store/featureFlags/featureFlagsSelectors';

export const ExpandedDarkThemeProvider: FC = ({children}) => {
  const hasP2P3DarkMode = useAppSelector(getHasP2P3DarkMode);
  const globalTheme = useUserTheme();
  const userThemeSetting = useAppSelector(getTheme);

  if (userThemeSetting === UserThemesEnum.DARK && hasP2P3DarkMode) {
    return <ThemeProvider theme={expandedDarkTheme}>{children}</ThemeProvider>;
  }

  return <ThemeProvider theme={globalTheme}>{children}</ThemeProvider>;
};
